import React, { useEffect, useMemo, useState } from "react";
import api from "../api";
import { downloadReport } from "../download";

export default function Reports() {
  const [catalog, setCatalog] = useState([]);
  const [sel, setSel] = useState(null);
  const [filters, setFilters] = useState({ q: "", status: "", department: "", branch: "", from: "", to: "" });
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => { api.get("/reports/catalog").then((r) => setCatalog(r.data?.data || [])); }, []);

  const groups = useMemo(() => catalog.reduce((a, r) => ((a[r.group] = a[r.group] || []).push(r), a), {}), [catalog]);

  const loadPreview = async (rep) => {
    setSel(rep); setLoading(true); setPreview(null);
    try {
      const res = await api.get(`/reports/${rep.key}`, { params: filters });
      setPreview(res.data?.data);
    } catch { setPreview(null); }
    setLoading(false);
  };

  const setF = (k, v) => setFilters((p) => ({ ...p, [k]: v }));

  return (
    <div>
      <h1>Reports & Export</h1>
      <p className="sub">Preview any register and export to CSV, Excel or PDF. Filters apply to the export.</p>

      <div style={{ display: "grid", gridTemplateColumns: "260px 1fr", gap: 16, alignItems: "start" }}>
        <div className="card" style={{ padding: 8 }}>
          {Object.entries(groups).map(([g, reps]) => (
            <div key={g}>
              <div className="grp" style={{ color: "#64748b" }}>{g}</div>
              {reps.map((rep) => (
                <button key={rep.key} className="btn link" style={{ display: "block", textAlign: "left", width: "100%", color: sel?.key === rep.key ? "#0f766e" : "#334155", fontWeight: sel?.key === rep.key ? 700 : 400 }}
                  onClick={() => loadPreview(rep)}>{rep.title}</button>
              ))}
            </div>
          ))}
        </div>

        <div>
          <div className="card" style={{ padding: 12, marginBottom: 12 }}>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(150px,1fr))", gap: 8 }}>
              <div><label>Search</label><input value={filters.q} onChange={(e) => setF("q", e.target.value)} /></div>
              <div><label>Status</label><input value={filters.status} onChange={(e) => setF("status", e.target.value)} /></div>
              <div><label>Department</label><input value={filters.department} onChange={(e) => setF("department", e.target.value)} /></div>
              <div><label>Branch</label><input value={filters.branch} onChange={(e) => setF("branch", e.target.value)} /></div>
              <div><label>From</label><input type="date" value={filters.from} onChange={(e) => setF("from", e.target.value)} /></div>
              <div><label>To</label><input type="date" value={filters.to} onChange={(e) => setF("to", e.target.value)} /></div>
            </div>
            <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
              <button className="btn" disabled={!sel} onClick={() => loadPreview(sel)}>Apply / Preview</button>
              <div style={{ flex: 1 }} />
              <button className="btn" disabled={!sel} onClick={() => downloadReport(sel.key, "csv", filters)}>CSV</button>
              <button className="btn" disabled={!sel} onClick={() => downloadReport(sel.key, "xlsx", filters)}>Excel</button>
              <button className="btn primary" disabled={!sel} onClick={() => downloadReport(sel.key, "pdf", filters)}>PDF</button>
            </div>
          </div>

          <div className="card">
            {!sel && <div className="empty">Select a report on the left.</div>}
            {sel && (
              <>
                <div className="toolbar"><b>{preview?.title || sel.title}</b><span style={{ color: "#64748b", fontSize: 13 }}>{loading ? "Loading…" : `${preview?.rows?.length || 0} rows (preview max 500)`}</span></div>
                <div className="tablewrap">
                  <table>
                    <thead><tr>{(preview?.columns || sel.columns).map((c) => <th key={c.key}>{c.label}</th>)}</tr></thead>
                    <tbody>
                      {(preview?.rows || []).map((row, i) => (
                        <tr key={i}>{(preview.columns).map((c) => <td key={c.key}>{row[c.key] === true || row[c.key] === 1 ? "Yes" : row[c.key] === false || row[c.key] === 0 ? "No" : row[c.key] ?? "—"}</td>)}</tr>
                      ))}
                      {!loading && !(preview?.rows || []).length && <tr><td colSpan={(sel.columns || []).length}><div className="empty">No rows.</div></td></tr>}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
